import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import counterReducer from "./slices/counterSlice";
import authReducer from "./slices/authSlice";
import appDataReducer from "./slices/appDataSlice";
import homescreenReducer from "./slices/homescreenSlice";
import observationReducer from "./slices/observationSlice";
import pulseCheckReducer from "./slices/pulseCheckSlice";
import shiftHandOverReducer from "./slices/shiftHandOverSlice"; // Updated to use new slice
import uiPreferencesReducer from "./slices/uiPreferencesSlice";
import themeReducer from "./slices/themeSlice";
import rackingWalkObservationsReducer from "./slices/rackingWalkObservationsSlice";
import rackingDamageChecklistReducer from "./slices/rackingDamageChecklistSlice";
import selectedRackingWalkReducer from "./slices/selectedRackingWalkSlice";
import rackingInspectionQuestionsReducer from "./slices/rackingInspectionQuestionsSlice";
import newHireOnboardingReducer from "./slices/newHireOnboardingSlice";
import manageEmployeesReducer from "./slices/manageEmployeesSlice";
import nhoReducer from "./slices/nhoSlice";
import employeeUpdatesReducer from "./slices/employeeUpdatesSlice";
import nhoAdminReducer from "./slices/nhoAdminSlice";
import leadershipWalkReducer from "./slices/leaderShipWalkSlice";
import siteEvaluationReducer from "./slices/siteEvaluationSlice";
import sparcWalkSlice from "./slices/sparcWalkSlice";
import sparcWalkInspectionReducer from "./slices/sparcWalkInspectionSlice";
import leadershipWalkRedirectReducer from "./slices/leadershipWalkRedirectSlice";
import contactUsReducer from "./slices/contactUsSlice";
import employeeProfileReducer from "./slices/employeeProfileSlice";
import qualityAuditReducer from "./slices/qualityAuditSlice";
import employeeLCWReducer from "./slices/employeeLCWSlice";
import siteEvalRedirectReducer from './siteEvalRedirectSlice';
import dloReducer from './slices/dloSlice';
import sessionLockReducer from './slices/sessionLockSlice';
import actionPlanReducer from './slices/actionPlanSlice';
import notificationReducer from './slices/notificationSlice';
import standupReducer from './slices/standUpSlice';
import standupRedirectReducer from './slices/standupRedirectSlice';
import rackingInspectionReducer from './slices/rackingInspectionSlice';
import configurationReducer from './slices/adminSlice';
import adminRolesReducer from './slices/adminRolesSlice';
import adminRoleStatsReducer from './slices/adminRoleStatsSlice';
import userManagementReducer from './slices/userManagementSlice';
import reportingConfigurationReducer from './slices/reportingConfigurationSlice';
import analyticsHubReducer from './slices/analyticsHubSlice';
import adminLocationsReducer from './slices/adminLocationsSlice';
import deliveryRpmReducer from './slices/deliveryRpmSlice';
import onePagerReducer from './slices/onePagerSlice';
import onePagerMobileReducer from './slices/onePagerMobileSlice';
import peopleHubReducer from './slices/peopleHubSlice';
import peopleHubActivityReducer from './slices/peopleHubActivitySlice';
import peopleConfigReducer from './slices/peopleConfigSlice';

import ticketingPortalReducer from './slices/ticketingPortalSlice';
import perfectTruckLocationSummaryReducer from './slices/perfectTruckLocationSummarySlice';
import asnLoadDetailsReducer from './slices/asnLoadDetailsSlice';
import asnLocationSummaryReducer from './slices/asnLocationSummarySlice';
import ticketingAnalyticsFiltersReducer from './slices/ticketingAnalyticsFiltersSlice';
import masterDataReducer from './slices/masterDataSlice';
import perfectTruckAnalyticsUiReducer from './slices/perfectTruckAnalyticsUiSlice';
import orderRulesFilterDataReducer from './slices/orderRulesFilterDataSlice';
import crewingAnalyticsUiReducer from './slices/crewingAnalyticsUiSlice';
import perfectTruckDashboardFiltersReducer from './slices/perfectTruckDashboardFiltersSlice';

const rootReducer = combineReducers({
  counter: counterReducer,
  auth: authReducer,
  appData: appDataReducer,
  homescreen: homescreenReducer,
  observation: observationReducer,
  pulseCheck: pulseCheckReducer,
  shiftHandOver: shiftHandOverReducer,
  sparcWalk: sparcWalkSlice,
  sparcWalkInspection: sparcWalkInspectionReducer,
  uiPreferences: uiPreferencesReducer,
  theme: themeReducer,
  rackingWalkObservations: rackingWalkObservationsReducer,
  rackingDamageChecklist: rackingDamageChecklistReducer,
  selectedRackingWalk: selectedRackingWalkReducer,
  rackingInspectionQuestions: rackingInspectionQuestionsReducer,
  rackingInspection: rackingInspectionReducer,
  newHireOnboarding: newHireOnboardingReducer,
  manageEmployees: manageEmployeesReducer,
  nho: nhoReducer,
  employeeUpdates: employeeUpdatesReducer,
  leadershipWalk: leadershipWalkReducer,
  leadershipWalkRedirect: leadershipWalkRedirectReducer,  nhoAdmin: nhoAdminReducer,
  contactUs: contactUsReducer,
  employeeProfile: employeeProfileReducer,
  qualityAudit: qualityAuditReducer,
  employeeLCW: employeeLCWReducer,
  siteEvaluation: siteEvaluationReducer,
  siteEvalRedirect: siteEvalRedirectReducer,
  dlo: dloReducer,
  sessionLock: sessionLockReducer,
  actionPlan: actionPlanReducer,
  notifications: notificationReducer,
  standUp: standupReducer,
  standupRedirect: standupRedirectReducer,
  configuration: configurationReducer,
  adminRoles: adminRolesReducer,
  adminRoleStats: adminRoleStatsReducer,
  userManagement: userManagementReducer,
  reportingConfiguration: reportingConfigurationReducer,
  analyticsHub: analyticsHubReducer,
  adminLocations: adminLocationsReducer,
  deliveryRpm: deliveryRpmReducer,
  onePager: onePagerReducer,
  onePagerMobile: onePagerMobileReducer,
  ticketingPortal: ticketingPortalReducer,
  perfectTruckLocationSummary: perfectTruckLocationSummaryReducer,
  asnLoadDetails: asnLoadDetailsReducer,
   ticketingAnalyticsFilters: ticketingAnalyticsFiltersReducer,

  asnLocationSummary: asnLocationSummaryReducer,
  masterData: masterDataReducer,
  perfectTruckAnalyticsUi: perfectTruckAnalyticsUiReducer,
  orderRulesFilterData: orderRulesFilterDataReducer,
  peopleHub: peopleHubReducer,
  peopleHubActivity: peopleHubActivityReducer,
  peopleConfig: peopleConfigReducer,
  crewingAnalyticsUi: crewingAnalyticsUiReducer,
  perfectTruckDashboardFilters: perfectTruckDashboardFiltersReducer,
});

// Wrap rootReducer so dispatching resetStore() returns every slice to its initialState.
// This is the correct pattern for shared-device logout.
const resettableRootReducer = (
  state: ReturnType<typeof rootReducer> | undefined,
  action: any
) => {
  if (action.type === 'RESET_STORE') {
    return rootReducer(undefined, action);
  }
  return rootReducer(state, action);
};

const store = configureStore({
  reducer: resettableRootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export const resetStore = () => ({ type: 'RESET_STORE' as const });

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;

// Use this custom hook to dispatch async thunks in components
export const useAppDispatch = () => useDispatch<AppDispatch>();

export default store;
